// var component, dom, inject, loggedinpage, markdown, normalpage, plainpage, ql, route, svg
const { component, dom, svg } = require('../odo/odojs/')
const inject = require('injectinto')
const plainpage = require('./plainpage')
const normalpage = require('./normalpage')
const loggedinpage = require('./loggedinpage')
const route = require('odo-route')
const markdown = require('../shared/markdown')
let ql = require('../odo/odoql/')
ql = ql.use('store')

route('/account', p => {
  return {
    page: 'account'
  }
})

inject.bind(
  'page:account',
  component({
    query: (params, hub) => {
      return {
        content: ql.store(['account'], 'content'),
        identity: ql.store('identity')
      }
    },
    render: (state, params, hub) => {
      document.title = 'Asset Altitude'
      return state.identity
        ? loggedinpage(
            [
              dom(
                '.page--full',
                dom(
                  'div',
                  {
                    style: {
                      'max-width': '30rem',
                      margin: '0 auto'
                    }
                  },
                  [
                    dom('p'),
                    dom('.page-header', dom('h2', 'Account')),
                    dom('p', [dom('b', 'Email:'), ` ${state.identity.email}`]),
                    dom('p', [dom('b', 'Name:'), ` ${state.identity.name}`]),
                    markdown(state.content.account),
                    dom(
                      'button.button',
                      {
                        onclick: e => {
                          e.preventDefault()
                          hub.emit('logout')
                        }
                      },
                      'Logout'
                    ),
                    dom('p')
                  ]
                )
              )
            ],
            'account'
          )
        : plainpage([dom('p', 'Not logged in')])
    }
  })
)
